import React, { Component } from 'react';
import './index.css';

class Square extends Component {
  render() {
    return <div className="loading-box">
      <div className="loading-inner-box"></div>
    </div>
  }
}

export default Square;



// WEBPACK FOOTER //
// ./src/components/Square/index.js